/**
 * Created by Ning Jiang on 4/17/2020.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../DeadwoodGameConfig";

export class DustIdleAnimation extends IdleAnimationController {

    private _dustSprite:PIXI.Sprite;
    private _spine:PIXI.spine.Spine | undefined;

    constructor() {
        super({
            startTime : 4,
            minInterval : 10,
            maxInterval : 30
        });
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, (event:GameEvent) => this.onStageResized(event.params[0]));
    }

    private onStageResized(resizeData:IResizeData):void {
        this.relocate();
    }

    private relocate():void {
        if(!this._dustSprite) {
            return;
        }
        this._dustSprite.position.set(GameConfig.instance.GAME_WIDTH * 0.5, StageManager.orientation === Orientation.PORTRAIT ? Math.ceil(NolimitApplication.screenBounds.height - this._dustSprite.parent.y / this._dustSprite.parent.scale.y) - GameConfig.instance.GAME_HEIGHT * 0.5 : GameConfig.instance.GAME_HEIGHT * 0.5);
    }

    protected onGameDataParsed(data:ParsedGameData):void {
    }

    protected hasWin():boolean {
        return false;
    }

    protected playIdleAnimation():void {
        if(!this._dustSprite) {
            this._dustSprite = new PIXI.Sprite();
            this._dustSprite.anchor.set(0.5);
            StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.BACKGROUND_IDLE.name).addChild(this._dustSprite);
            this.relocate();
        }

        if (this._spine){
            return;
        }

        const dustSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("dust"));
        dustSpine.autoUpdate = true;
        dustSpine.state.addListener({complete : () => TweenLite.to(this, 0.5, {onComplete : () => this.recycleSpine(dustSpine)})});
        dustSpine.state.clearTrack(0);
        dustSpine.skeleton.setToSetupPose();
        dustSpine.state.setAnimation(0, "animation", false);
        this._dustSprite.addChild(dustSpine);
        this._spine = dustSpine;

        // Logger.logDev("playing dust.");
    }

    private recycleSpine(dustSpine:PIXI.spine.Spine):void {
        dustSpine.visible = false;
        dustSpine.state.setEmptyAnimation(0, 0);
        this._dustSprite.removeChild(dustSpine);
        dustSpine.destroy();
        this._spine = undefined;
    }
}